<div class="wrapper-main" fxLayoutGap="10px" fxLayout="column" fxLayoutAlign="start start">
    <span>{{ Utils.getValueFromTranslation(customFieldForm.value.name, localeId) }}</span>
    <div class="checkboxes-wrapper" fxLayout="column">
        <mat-checkbox
            fxLayoutGap="10px"
            fxLayout="column"
            *ngFor="let option of customFieldForm.value.options"
            [checked]="getCheckedOption(option)"
            (change)="updateValue($event.checked, option)"
        >
            {{ Utils.getValueFromTranslation(option.value, localeId) }}
        </mat-checkbox>
    </div>
</div>
